import React, { useState, useCallback } from 'react';
import {
  StyleProp,
  Text,
  TextStyle,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';

import CustomModal from './CustomModal';
import { createUseStyles } from 'core/src';

interface CustomActionsProps {
  renderIcon?: () => React.ReactNode;
  wrapperStyle?: StyleProp<ViewStyle>;
  containerStyle?: StyleProp<ViewStyle>;
  iconTextStyle?: StyleProp<TextStyle>;
  onSend: (messages: any) => void;
  groupUsers: any;
  isTag: boolean;
  setMentions: any;
  dispatch: any;
}

const CustomActions: React.FC<CustomActionsProps> = ({
  renderIcon,
  iconTextStyle,
  containerStyle,
  wrapperStyle,
  onSend,
  groupUsers,
  isTag,
  setMentions,
  dispatch,
}) => {
  const [modalVisible, setModalVisible] = useState(false);

  const { styles } = useStyles();

  const onActionsPress = useCallback(() => {
    setModalVisible(true);
  }, []);

  const handleConfirm = (selectedUsers: any) => {
    const convertedArray = selectedUsers.map((item: any) => `@${item}`);
    dispatch(setMentions(convertedArray));
  };

  const renderIconComponent = useCallback(() => {
    if (renderIcon) {
      return renderIcon();
    }
    return (
      <View style={[styles.wrapper, wrapperStyle]}>
        <TouchableOpacity
          style={[styles.container, containerStyle]}
          onPress={onActionsPress}
        >
          <Text style={[styles.iconText, iconTextStyle]}>@</Text>
        </TouchableOpacity>
      </View>
    );
  }, [renderIcon, wrapperStyle, iconTextStyle]);

  return (
    <>
      {/* <TouchableOpacity
        style={[styles.container, containerStyle]}
        onPress={onActionsPress}
      > */}
      {renderIconComponent()}
      {/* </TouchableOpacity> */}
      <CustomModal
        isTag={isTag}
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        users={groupUsers}
        onConfirm={handleConfirm}
      />
    </>
  );
};

export default CustomActions;

const useStyles = createUseStyles(({ colors, theme }) => ({
  container: {
    // backgroundColor: 'red',
  },
  wrapper: {
    // borderRadius: 13,
    // borderColor: 'red',
    // borderWidth: 2,
    // backgroundColor: 'pink',
  },
  iconText: {
    color: colors.menu,
    // fontWeight: 'bold',
    fontSize: 30,
    // backgroundColor: 'red',
    textAlign: 'center',
    marginBottom: 6,
  },
}));
